import { sizes } from './tokens/sizes';

export const layoutSizes = {
  topBar: {
    height: 48,
    logoWidth: 36,
    logoHeight: 36,
    menuOffsetY: 1,
    menuTranslateY: -1,
  },
  sidebar: {
    width: sizes.sidebarWidth,
    drawerWidth: sizes.sidebarWidth,
    collapsedWidth: 56,
    itemMinHeight: 32,
    iconMinWidth: 26,
    iconSize: 16,
  },
  popover: { minWidth: 220, itemHeight: 36 },
  calendar: { maxWidth: 360 },
  auth: { signInMaxWidth: 520, signUpMaxWidth: 560 },
  content: { maxWidth: 1600 },
} as const;
